import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div<{
  $hasError?: boolean
  $disableHover?: boolean
  $isDragging?: boolean
}>`
  display: flex;

  padding: ${Spacing.L};
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.XS};
  align-self: stretch;
  border-radius: 8px;
  border: 1px dashed ${({ $hasError }) => ($hasError ? Colors.Red50 : Colors.Neutral30)};
  background: ${({ $isDragging }) => ($isDragging ? Colors.Blue10 : Colors.White)};
  cursor: pointer;
  height: 220px;
  justify-content: center;

  ${({ $hasError, $disableHover }) =>
    !$hasError &&
    !$disableHover &&
    css`
      &:hover {
        border: 1px solid ${Colors.Blue50};
        background: ${Colors.Blue10};
      }
    `}

  ${Media.Phone`
    height: 192px;
  `}
`

export const UploadContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`
export const Img = styled.img`
  width: 80px;
  height: 80px;
  flex-shrink: 0;

  ${Media.Phone`
    width: 60px;
    height: 60px;

  `}
`

export const Title = styled.div<{ $disableHover?: boolean }>`
  color: ${Colors.Neutral90};
  text-align: center;
  ${Typography.Body};
  ${FontWeights.Medium}

  ${({ $disableHover }) =>
    !$disableHover &&
    css`
      ${Container}:hover & {
        color: ${Colors.Blue50};
      }
    `}
`

export const Description = styled.div`
  color: ${Colors.Neutral50};
  text-align: center;
  ${Typography.Caption};
  ${FontWeights.Regular}
`
export const Progress = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: ${Colors.Neutral10};
`

export const ProgressBar = styled.div<{ progress: number }>`
  width: ${props => `${props.progress}%`};
  height: inherit;
  border-radius: inherit;
  background-color: ${Colors.Blue50};
  transition: width 0.15s ease-out;
`

export const Error = styled.div`
  text-align: center;
  color: ${Colors.Red50};
  ${Typography.Caption};
  ${FontWeights.Regular}
`
